import {
  GET_SAVINGS,
  LOADING_GET_SAVINGS,
  SET_SAVING,
  LOADING_UPDATE_SAVING,
} from "../types";

const INITIAL_STATE = {
  savings: [],
  saving: {},
  loadingGetSavings: false,
  loadingUpdateSaving: false,
};

const savingsReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case GET_SAVINGS:
      return { ...state, savings: action.payload };
    case SET_SAVING:
      return { ...state, saving: action.payload };
    case LOADING_GET_SAVINGS:
      return { ...state, loadingGetSavings: action.payload };
    case LOADING_UPDATE_SAVING:
      return { ...state, loadingUpdateSaving: action.payload };

    default:
      return state;
  }
};

export default savingsReducer;
